module.exports = __webpack_public_path__ + "static/media/lkw-40t-s.ac2af639.svg";